import { CssuaUserAgent } from "@/typeDefinitions";
import cssua from "./cssua";

export default abstract class UserAgent {

  // typed cssua User Agent
  private static cssuaUserAgent = cssua.userAgent as CssuaUserAgent;

  // OS
  static get windows() { return "Windows"; }
  static get macos() { return "Mac/iOS"; }
  static get ios() { return "ios"; }
  static get android() { return "android"; }
  static get linux() { return "Linux"; }

  // Browsers
  static get edge() { return "edge"; }
  static get chrome() { return "chrome"; }
  static get firefox() { return "firefox"; }
  static get safari() { return "safari"; }
  static get opera() { return "opera"; }
  static get ie() { return "ie"; }
  static get vivaldi() { return "vivaldi"; }

  // OS logic
  static get isWindows() { return this.cssuaUserAgent.desktop === "windows"; }
  static get isMacos() { return this.cssuaUserAgent.desktop === "macintosh"; }
  static get isLinux() { return this.cssuaUserAgent.desktop === "linux"; }
  static get isUnix() { return this.cssuaUserAgent.desktop === "unix"; }
  static get isAndroid() { return this.cssuaUserAgent.mobile === "android"; }
  static get isIos() { return this.cssuaUserAgent.mobile === "iphone" || this.cssuaUserAgent.mobile === "ipad"; }
  static get isDesktop() { return this.isWindows || this.isMacos; }
  static get isMobile() { return this.isAndroid || this.isIos; }

  // Browser logic
  static get isEdge() { return this.cssuaUserAgent.edge; }
  static get isChrome() { return this.cssuaUserAgent.chrome; }
  static get isFirefox() { return this.cssuaUserAgent.firefox; }
  static get isSafari() { return this.cssuaUserAgent.safari; }
  static get isOpera() { return this.cssuaUserAgent.opera; }
  static get isVivaldi() { return this.cssuaUserAgent.vivaldi; }
  static get isIe() { return this.cssuaUserAgent.ie; }

  static get os() {
    if (this.isWindows) { return this.windows; }
    if (this.isMacos) { return this.macos; }
    if (this.isAndroid) { return this.android; }
    if (this.isIos) { return this.ios; }
    if (this.isLinux || this.isUnix ) { return this.linux; }
  }

  static get browser() {
    if (this.isEdge) { return this.edge; }
    if (this.isChrome) { return this.chrome; }
    if (this.isFirefox) { return this.firefox; }
    if (this.isSafari) { return this.safari; }
    if (this.isOpera) { return this.opera; }
    if (this.isVivaldi) { return this.vivaldi; }
    if (this.isIe) { return this.ie; }
  }
}
